var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCloseRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0711 14.3435L25.6569 12.9293L20 18.5862L14.3431 12.9293L12.9289 14.3435L18.5858 20.0004L12.9289 25.6572L14.3431 27.0714L20 21.4146L25.6569 27.0714L27.0711 25.6572L21.4142 20.0004L27.0711 14.3435Z",
    fill: "#EE5252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0711 14.3435L25.6569 12.9293L20 18.5862L14.3431 12.9293L12.9289 14.3435L18.5858 20.0004L12.9289 25.6572L14.3431 27.0714L20 21.4146L25.6569 27.0714L27.0711 25.6572L21.4142 20.0004L27.0711 14.3435Z",
    fill: "#EE5252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0711 14.3435L25.6569 12.9293L20 18.5862L14.3431 12.9293L12.9289 14.3435L18.5858 20.0004L12.9289 25.6572L14.3431 27.0714L20 21.4146L25.6569 27.0714L27.0711 25.6572L21.4142 20.0004L27.0711 14.3435Z",
    fill: "#EE5252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0711 14.3435L25.6569 12.9293L20 18.5862L14.3431 12.9293L12.9289 14.3435L18.5858 20.0004L12.9289 25.6572L14.3431 27.0714L20 21.4146L25.6569 27.0714L27.0711 25.6572L21.4142 20.0004L27.0711 14.3435Z",
    fill: "#EE5252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseRed);
export default __webpack_public_path__ + "static/media/ico-close-red.bb44a74e1ae8ccb7eb5243a4b92ee9b8.svg";
export { ForwardRef as ReactComponent };